<template>
  <div v-if="item.children">
    <template v-if="item.children.length === 0">
      <el-menu-item :index="item.id.toString()" :key="item.id" @click="openPath(item.pageType, item.id)">
        <span class="name"> {{item.name}}</span>
      </el-menu-item>
    </template>

    <el-submenu v-else :index="item.id.toString()" :key="item.id">
      <template slot="title">
        <span class="name"> {{item.name}}</span>
      </template>
      <template v-for="child in item.children">
        <sidebar-item
          v-if="child.children&&child.children.length>0"
          :item="child"
          :key="child.id"
          />
        <el-menu-item v-else :key="child.id" :index="child.id.toString()" @click="openPath(child.pageType, child.id)">
          <span class="name"> {{child.name}}</span>
        </el-menu-item>
      </template>
    </el-submenu>
  </div>
</template>

<script>
export default {
  name: 'SidebarItem',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    openPath (pageType, id) {
      // console.log('pageType=', pageType, 'id=', id)
      if (pageType === 1) {
        this.$router.push({
          path: '/GoodsList',
          query: {
            // pageType,
            id
          }
        })
      }
      if (pageType === 12) {
        this.$router.push({
          path: '/Sweat',
          query: {
            id
          }
        })
      }
      if (pageType === 2) {
        this.$router.push({
          path: '/Seamless',
          query: {
            id
          }
        })
      }
      if (pageType === 3) {
        this.$router.push({
          path: '/Warp',
          query: {
            id
          }
        })
      }
      if (pageType === 4) {
        this.$router.push({
          path: '/OurYarns',
          query: {
            id
          }
        })
      }
      if (pageType === 5) {
        this.$router.push({
          path: '/OurCertifications',
          query: {
            id
          }
        })
      }
      if (pageType === 6) {
        this.$router.push({
          path: '/DyeingInnovation',
          query: {
            id
          }
        })
      }
      if (pageType === 7) {
        this.$router.push({
          path: '/Headquarters',
          query: {
            id
          }
        })
      }
      if (pageType === 8) {
        this.$router.push({
          path: '/Locations',
          query: {
            id
          }
        })
      }
      if (pageType === 9) {
        this.$router.push({
          path: '/Partners',
          query: {
            id
          }
        })
      }
      if (pageType === 10) {
        this.$router.push({
          path: '/OurTeam',
          query: {
            id
          }
        })
      }
      if (pageType === 11) {
        this.$bus.$emit('closeNav1')
        this.$router.push({
          path: '/Link',
          query: {
            id
          }
        })
      }
    }
  }
}
</script>
<style>
.show{
  border: 1px solid red;
  display: block!important;
}
</style>
